import Container from "../../../utils/Container";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { getOffer } from "../../../api/website/home/homeApi";
import useSEO from "../../../utils/seo";

const OfferPage = () => {
  const { id } = useParams();
  const [Offers, setOffers] = useState("");
  useEffect(() => {
    getOffer(setOffers, id);
  }, [id]);
  useSEO({
    title: Offers.offerTitle,
    description: Offers.shortDescription,
    image: Offers.coverImage,
    url: `https://dhoorbin.com/offer/${id}/${Offers.offerTitle}`,
    canonical: "https://dhoorbin.com",
    keywords: "travel, hotel, tour, booking",
    publisher: "Dhoorbin",
    robots: "index, follow",
    lang: "en",
  });
  return (
    <>
      {Offers && (
        <div className="w-full h-auto space-y-4">
          <div>
            <div className="w-full h-full lg:h-[400px]">
              <img
                src={Offers.coverImage}
                alt=""
                className="w-full h-full object-contain lg:object-cover"
              />
            </div>
            <Container>
              <div className="space-y-5 py-10">
                <div className="border p-3 lg:p-10 rounded-lg shadow-lg border-1 border-gray-200 flex flex-col justify-center items-center gap-y-3 bg-white px-10">
                  <p className="text-md lg:text-2xl font-bold uppercase text-[#2155ad] text-center">
                    {Offers.offerTitle}
                  </p>
                  <p className="text-xs text-center lg:text-sm text-black/50 text-wrap">
                    {Offers.shortDescription}
                  </p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-10">
                  <div className="col-span-0 lg:col-span-2">
                    <div
                      className="text-gray-500 leading-10 text-sm bg-white p-5 lg:p-10 rounded-lg shadow-lg border-1 border-gray-200 border"
                      dangerouslySetInnerHTML={{
                        __html: Offers.description,
                      }}
                    />
                  </div>
                  <div className="w-full space-y-6 mt-3 lg:mt-0">
                    {Offers.code && (
                      <div className="border rounded-lg shadow-lg bg-white overflow-hidden">
                        <div className="bg-[#153875] py-2 text-white font-bold text-center text-md">
                          <p>How to Redeem Your Coupon</p>
                        </div>
                        <div className="px-4 py-4 flex flex-col justify-center items-center gap-y-2">
                          <div className="bg-[#1538753d] border-4 border-[#1538753d] border-dotted w-fit p-5 rounded-lg">
                            <p>{Offers.code}</p>
                          </div>
                          <div className="px-4 text-center">
                            <p className="text-sm text-black/50">
                              Copy the coupon and use it on checkout within{" "}
                              <br />
                              <span className="text-[#ff004c] font-bold">
                                {Offers.expirationDate.split("T")[0]}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {Offers.conditions !== `` && (
                      <div className="border rounded-lg shadow-lg bg-white overflow-hidden">
                        <div className="bg-[#ff004c] py-2 text-white font-bold text-center text-md">
                          <p>Terms and Conditions</p>
                        </div>
                        <div className="px-4 py-4 flex flex-col justify-center items-center gap-y-2">
                          <div className="bg-[#15387521] w-fit p-5 rounded-lg">
                            <div
                              className="leading-8 text-sm text-black/90"
                              dangerouslySetInnerHTML={{
                                __html: Offers.termsAndConditions,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </div>
      )}
    </>
  );
};

export default OfferPage;
